import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { notification, Typography } from 'antd';

import { fetchTableBaseInfo } from '@/features/asset-detail';

import styles from './TableNameLink.module.css';

const { Link } = Typography;

type TableNameLinkProps = {
  tableName: string;
  fqn: string;
};

export const TableNameLink = ({ tableName, fqn }: TableNameLinkProps) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      await fetchTableBaseInfo(fqn);
      navigate(`/table/${fqn}`);
    } catch (error) {
      notification.error({
        message: '정보를 불러올 수 없습니다.',
        description: '이동할 수 없습니다. 다시 시도해 주세요.',
        duration: 2,
        placement: 'bottomLeft',
      });
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Link ellipsis className={styles.link} onClick={handleClick} disabled={isLoading}>
      {tableName}
    </Link>
  );
};
